/** @format */

import { toRegexp, toPath } from "@riotjs/route";

import contracts from "@tags/pages/croco-desk/contracts.riot";
import transaction from "@tags/pages/croco-desk/transaction.riot";
import top from "@tags/pages/croco-desk/top.riot";
import order from "@tags/pages/croco-desk/order.riot";
import invoice from "@tags/pages/croco-desk/invoice.riot";
import delivery from "@tags/pages/croco-desk/delivery.riot";
import member from "@tags/pages/croco-desk/member.riot";
import rules from "@tags/pages/croco-desk/rules.riot";

const pages = [
  {
    path: "/croco-desk",
    is: "top-tag",
    component: top,
  },
  {
    path: "/croco-desk/order",
    is: "order-tag",
    component: order,
  },
  {
    path: "/croco-desk/invoice",
    is: "invoice-tag",
    component: invoice,
  },
  {
    path: "/croco-desk/delivery",
    is: "delivery-tag",
    component: delivery,
  },
  {
    path: "/croco-desk/contracts",
    is: "contracts-tag",
    component: contracts,
  },
  {
    path: "/croco-desk/transaction",
    is: "transaction-tag",
    component: transaction,
  },
  {
    path: "/croco-desk/member",
    is: "member-tag",
    component: member,
  },
  {
    path: "/croco-desk/rules",
    is: "rules-tag",
    component: rules,
  },
];

for (const page of pages) {
  page.route = toRegexp(page.path, [], { endsWith: "([#?].*)?" });
}

const routes = {
  pages,
  makePath: (name, param) =>
    toPath(pages.find((v) => v.is == name).path, param),
};

export default routes;
